import React from 'react'
import PropTypes from 'prop-types';
import Documents from './documents/Documents';

function Index(
    {
        expanded
    }) {
    return expanded && <Documents expanded={expanded}/>
}

Index.propTypes = {
    expanded: PropTypes.bool,
}

export default Index;